import { Injectable } from '@angular/core';
import { AppRole } from '../auth/app-role';

const SUPERADMIN_HOSTS = new Set([
  'stg.superadmin.wealthmax.co.uk',
  'superadmin.finops.co.uk'
]);

const BUSINESS_HOSTS = new Set(['stg.crm.wealthmax.co.uk']);

const CUSTOMER_HOSTS = new Set(['stg.portal.wealthmax.co.uk']);

@Injectable({ providedIn: 'root' })
export class DomainService {
  getAppSurface(hostname: string): AppRole {
    const host = hostname.toLowerCase();

    if (SUPERADMIN_HOSTS.has(host)) {
      return 'superadmin';
    }

    if (BUSINESS_HOSTS.has(host)) {
      return 'business';
    }

    if (CUSTOMER_HOSTS.has(host)) {
      return 'customer';
    }

    return 'customer';
  }

  getRoleEntryPath(hostname: string): string {
    const surface = this.getAppSurface(hostname);
    return `/${surface}/login`;
  }
}